import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Footer, PrimeTemplate } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';

declare var $: any;

@Component({
    selector: 'project-pop',
    templateUrl: 'project-popup.component.html',
    standalone: true,
    imports: [DialogModule, PrimeTemplate, TooltipModule, DropdownModule, FormsModule, Footer, TranslateModule]
})
export class ProjectPopUpComponent implements OnInit {
  private translate = inject(TranslateService);


  data: string;
  state: string;
  display: boolean = false;
  periodOptions: any;
  stateOptions: any;

  @Input() idx: number;
  @Input() params: any;
  @Output() closepopup: EventEmitter<boolean> = new EventEmitter();
  @Output() saveData: EventEmitter<{ params: any, indx: number }> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.periodOptions = [
      { name: this.translate.instant('widgets.user-projects.OneMonth'), value: 'One Month' },
      { name: this.translate.instant('widgets.user-projects.TwoMonths'), value: 'Two Months' },
      { name: this.translate.instant('widgets.user-projects.ThreeMonths'), value: 'Three Months' }
    ];

    this.stateOptions = [
      { name: this.translate.instant('widgets.party-activities.All'), value: 'All' },
      { name: this.translate.instant('widgets.party-activities.OpenedAndWorking'), value: 'OpenedAndWorking' },
      { name: this.translate.instant('widgets.party-activities.Closed'), value: 'Closed' }
    ];
  }

  ngOnInit() {
    if (this.params != null) {
      this.state = this.params.state;
      this.data = this.params.date;
    }
    else {
      this.clearDefault();
    }

    this.display = true;
  }

  clearDefault() {
    this.state = "All";
    this.data = "One Month";
  }

  stateChange(state: string) {

    this.state = state;
  }

  getData(name: string) {
    return 'widgets.user-projects.' + name;
  }

  getState(state: string) {
    return 'widgets.party-activities.' + state;
  }

  cancel() {
    this.closepopup.next(true);
  }

  confirm() {
    let parms = {
      state: this.state,
      date: this.data
    }

    this.saveData.next({ params: parms, indx: this.idx });
    this.closepopup.next(true);
    this.display = false;
  }
}
